module.exports = __webpack_public_path__ + "img/solution_institutionalcare_sys_en.9eec1e18.jpg";